export const SENSORS_LOADING_MESSAGE="Estamos consultando la información de tus sensores";
export const ERROR_401_MESSAGE="Ups, parece que te has estado inactivo por mucho tiempo. Ingresa nuevamente ";
export const GRAPHS_LOADING_MESSAGE="Estamos cargando la información de tus sensores";

export const NOT_ALLOWED_ORIENTATION = {
    PORTRAIT_PRIMARY: "portrait-primary",
    PORTRAIT_SECONDARY: "portrait-secondary",
};

export const OPERATORS = [
    {
        label: "Telit",
        value: "Telit"
    },
    {
        label: "Claro",
        value: "Claro"
    },
    {
        label: "Movistar",
        value: "Movistar"
    },
    {
        label: "ETB",
        value: "ETB"
    },
    {
        label: "Tigo",
        value: "Tigo"
    },
    {
        label: "Avantel",
        value: "Avantel"
    },
    {
        label: "Virgin",
        value: "Virgin"
    }

];

export const VARIABLES = [
    { variableId: "CP", label: "Corriente del panel solar", sonda: false, unit: "mA", maxLimit: "3200", minLimit: "-1" },
    { variableId: "CB", label: "Corriente de la batería", sonda: false, unit: "mA", maxLimit: "3200", minLimit: "-1"},
    { variableId: "VB", label: "Voltaje de la batería", sonda: false, unit: "V", maxLimit: "26", minLimit: "0" },
    { variableId: "VP", label: "Voltaje del panel solar", sonda: false, unit: "V", maxLimit: "26", minLimit: "0" },
    { variableId: "Rs", label: "Nivel de señal celular", sonda: false, unit: "%", maxLimit: "100", minLimit: "-100" },
    { variableId: "Rd", label: "Iluminancia", sonda: false, unit: "Lux", maxLimit: "180000", minLimit: "0" },
    { variableId: "RdFs", label: "Radiación Solar 400-700nm", sonda: false, unit: "u*mol/m²*s", maxLimit: "2500", minLimit: "0" },
    { variableId: "HA", label: "Humedad ambiente", sonda: false, unit: "%", maxLimit: "100", minLimit: "0" },
    { variableId: "TA", label: "Temperatura ambiente", sonda: false, unit: "°C", maxLimit: "125", minLimit: "-25" },
    { variableId: "HS", label: "Humedad suelo", sonda: true, unit: "%", maxLimit: "100", minLimit: "0" },
    { variableId: "TS", label: "Temperatura suelo", sonda: true, unit: "°C", maxLimit: "125", minLimit: "-25" },
    { variableId: "CE", label: "Conductividad eléctrica", sonda: true, unit: "mS/m2", maxLimit: "10", minLimit: "0" },
    { variableId: "PH", label: "PH", sonda: true, unit: "-", maxLimit: "14", minLimit: "0" },        
    { variableId: "KI", label: "Potasio", sonda: true, unit: "-", maxLimit: "600", minLimit: "0" },
    { variableId: "NI", label: "Nitrógeno", sonda: true, unit: "-", maxLimit: "600", minLimit: "0" },
    { variableId: "PI", label: "Fósforo", sonda: true, unit: "-", maxLimit: "600", minLimit: "0" }
];

export const VARIABLES_GET_MEASURE = ['TA', 'HA', 'Rd','RdFs','TS', 'HS','CE','PH','NI', 'PI', 'KI',
    'TS2','HS2','CE2','PH2','NI2','PI2','KI2','VB','CB','VP','CP','Rs'];
